import React,{Component} from 'react';
import {Tabs,Badge} from 'antd';
import CommonBreadcrumb from "@components/CommonBreadcrumb"; 
import WaitTable from "./components/wait/WaitTable";
import OutTable from './components/Out/OutTable';
import './index.less' ;

class Registration extends Component {
    constructor(props) {
        super(props)
        this.state = {
            waitIntoNum: "",
            tabKay: 'wait',
        }
        this.intoWarehouseRef = React.createRef()
        this.waitWarehouse = React.createRef()
    }

    tabsOnChange(key) {
        this.setState({
            tabKay: key,
        },() => {

        })
    }
    setWaitNum(num){
        this.setState({
            waitNum :  num
        })
    }
    render() {
        let tabKey = this.state.tabKay
        const { waitNum} = this.state;
        return (
            <div className="outWarehouse" >
                <CommonBreadcrumb list={[
                    {name: __getServerLanguage('ChuKuGuanLi')},
                ]}></CommonBreadcrumb>
                <div className="customer-screen">
                    <Tabs defaultActiveKey="wait" onChange={this.tabsOnChange.bind(this)}
                        items={[
                           {
                                key: 'wait', // 待出库
                                label:(<>
                                    <span className="mr_4">
                                      {__getServerLanguage('DaiChuKu')}
                                    </span>
                                    <Badge count={waitNum}></Badge>
                                </>),
                                children: <WaitTable key={"WaitTable"} setNum={(num)=>this.setWaitNum(num)} />,
                            },{
                                key: 'out', //已出库
                                label:__getServerLanguage('YiChuKu'),
                                children: (<OutTable key={"OutTable"} />),
                            }
                        ]}
                    >
                    </Tabs>
                </div>
            </div>
        )
    }
}

export default Registration
